<template>
  <el-drawer
    v-if="visible"
    :title="$l('dialog_title_readBox') || '智能提取箱贴箱号'"
    visible
    show-close
    direction="rtl"
    :size="1000"
    @close="() => $refs.main.cancel()"
  >
    <div class="drawer-main">
      <Main
        ref="main"
        :amzFtyNoticeOutCode="amzFtyNoticeOutCode"
        :listAmzFtyNoticeOutDocCode="listAmzFtyNoticeOutDocCode"
        @reload="$emit('reload')"
        @close="close()"
      />
    </div>
    <div class="drawer-footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    amzFtyNoticeOutCode: { type: String, default: '' },
    listAmzFtyNoticeOutDocCode: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
